import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import CamerasLayout from '../views/CamerasLayout.vue';
import Callback from '../views/Callback.vue';
import store from './store.js';

Vue.use(Router);

const routes = [
  
  {
    path: '/callback',
    name: 'Callback',
    component: Callback
  },
  { 
    path: '/', 
    component: () => import('@/views/Index'),
    meta: {
      requiresAuth: true
    },
    //
    children: [
      { 
        path: '', 
        name: 'Home', 
        meta: {
          requiresAuth: true
        },
        component: Home 
      },
      { 
        path: '/monitor', 
        name: 'Cams-Layout', 
        meta: {
          requiresAuth: true
        },
        component: CamerasLayout 
      },
      
    ]
  },
  
  /*  
    component: Home 
  },
  { 
    path: '/monitor', 
    name: 'Monitor', 
    meta: {
      requiresAuth: true
    },
    component: Monitor 
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback
  }
  /**/
]

let router = new Router ({
  mode:"history",
  routes
})

router.beforeEach(async (to, from, next) => {
  if (store.state.isAuthenticated) {
    //already signed in, we can navigate anywhere
    next()
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    //authentication is required. Trigger the sign in process, including the return URI
    store.dispatch('authenticate',"/monitor").then(() => {
      next();
    });
    
  } else {
    //No auth required. We can navigate
    next()
  }
})

export default router